 /**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:56 2019-07-10
 */

 import { defaultNullValue } from 'src/config';
 import Api from 'src/util/api';
 import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
 
export declare namespace CrcConfigDOI {
     export interface RowDataI {
         crc: string;
         file_name: string;
         status: number;
         id: number;
     }
 
     export interface QueryRowDataParamsI extends PageDo {
     }

     export interface FormDataI {
        crc: string;
        file_name: string;
     }
}


export default class CrcConfigApi {
     /**
      * 查询列表
      * @param {GetPeopleManageListParamsI} params
      * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
      */
     static async searchList(params: CrcConfigDOI.QueryRowDataParamsI): Promise<ResultPageDo<CrcConfigDOI.RowDataI[]>> {
         return Api.post('/monitor/select/crc_file', {
            ...params,
         });
     }

     static async add(data:CrcConfigDOI.FormDataI):Promise<Result<any>> {
		return Api.post('/monitor/add/crc_file', data)
	 }

    static async delete(id: Integer):Promise<Result<any>> {
		return Api.post('/monitor/delete/crc_file', {id})
    }

 }
 